export default __webpack_public_path__ + "static/media/delete-account.a24c6c0a.jpg";